import { render } from "./cut-out-corner-card.vue?vue&type=template&id=4f0fcadf"
import script from "./cut-out-corner-card.vue?vue&type=script&lang=js"
export * from "./cut-out-corner-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__